<template>
  <div class="main">
    <el-form
      id="formLogin"
      class="user-layout-login"
      ref="formLogin"
      :model="userInfo"
    >
    <!-- 火狐浏览器解决表单自动填充 让浏览器把密码填到一个隐藏的密码输入框里面-->
    <input type="password" style="display: none;">
    <div v-if="!isCompleteVerification" class="forget-password-title">忘记密码</div>
    <div v-if="!isCompleteVerification">
      <el-form-item>
        <el-input style="display:none"></el-input>
        <el-input
          placeholder="请输入手机号"
          v-model="userInfo.mobile"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-row :gutter="22">
          <el-col :span="18">
             <!-- autocomplete='new-password'解决谷歌浏览器表单自动填充-->
            <el-input autocomplete='new-password'
              type="password"
              placeholder="请输入验证码"
              v-model="userInfo.code"
            >
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="text"  @click="getVerificationCode" v-if="countdown === 60">获取验证码</el-button>
            <el-button type="text" v-else>{{ countdown }}s后重新获取</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item style="margin-top:24px">
        <el-button
          type="primary"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
          @click="handleValidate"
        >
          验证
        </el-button>
      </el-form-item>
    </div>
    <div v-else>
      <p class="tip">密码为6-20个字符（数字、字母符号至少包含两种)</p>
      <el-form-item>
        <el-select
          v-model="userInfo.marketId"
          placeholder="请选择市场"
          style="width:100%;"
        >
          <el-option
            v-for="item in marketList"
            :key="item.key"
            :label="item.val"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-row :gutter="10">
          <el-col :span="22">
            <el-input :type="passwordHidden ? 'password' : 'text'"
              placeholder="请输入新密码"
              v-model="userInfo.password"
            >
            </el-input>
          </el-col>
          <el-col :span="2">
            <img :src="passwordHidden ? hideImg : visualImg" class="password_type" @click="passwordHidden = !passwordHidden">
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-row :gutter="10">
          <el-col :span="22">
            <el-input :type="confirmPasswordHidden ? 'password' : 'text'"
              placeholder="请再次输入密码"
              v-model="userInfo.confirmPassword"
            >
            </el-input>
          </el-col>
          <el-col :span="2">
              <img :src="confirmPasswordHidden ? hideImg : visualImg" class="password_type" @click="confirmPasswordHidden = !confirmPasswordHidden">
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item style="margin-top:24px">
        <el-button
          type="primary"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
          @click="handleResetPassword"
        >
         确认
        </el-button>
      </el-form-item>
    </div>

    </el-form>
  </div>
</template>

<script>
import user from '@/api/user.js'
import api from '@/api'
import { mapActions } from 'vuex'
import visualImg from '@/assets/password_visual.png'
import hideImg from '@/assets/password_hide.png'
let COUNTDOWN

export default {
  data () {
    return {
      tmp: '',
      visualImg: visualImg,
      hideImg: hideImg,
      passwordHidden: true, // 密码显示类型，true是默认隐藏，false是显示
      confirmPasswordHidden: true, // 确认密码显示类型，true是默认隐藏，false是显示
      // 用户信息
      userInfo: {
        mobile: '', // 用户账号
        password: '', // 密码
        confirmPassword: '', // 确认密码
        code: '', // 验证码
        marketId: '' // 市场
      },
      isCompleteVerification: false, // 是否通过验证码验证了
      countdown: 60, // 验证码获取倒计时
      validationCompanyRules: [ // 验证码空校验
        { name: 'mobile', message: '请输入11位手机号' },
        { name: 'code', message: '请输入验证码' },
      ],
      pswCompanyRules: [ // 密码空校验
        { name: 'password', message: '请输入密码' },
        { name: 'confirmPassword', message: '请输入确认密码' },
      ],
      state: {
        time: 60,
        loginBtn: false,
        smsSendBtn: false,
      },
      marketList: [],
      checkToken: '' // 忘记密码临时token
    }
  },
  computed: {
    redirect () {
      return this.$route.query.redirect || '/home'
    }
  },
  created () {

  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    // 获取市场
    getMarket () {
      api.common.getSelectData('market_code_name').then(res => {
        this.marketList = res.data
      })
    },
    // 获取验证码
    getVerificationCode () {
      if (this.$utils.phone(this.userInfo.mobile)) { // 先校验手机号码是否填写正确
        this.startCountdown() // 开始倒计时
        let params = {
          phone: this.userInfo.mobile,
          bizType: 'reg_mobile'
        }
        user.smsCode(params) // 发送获取验证码请求
      }
    },
    // 开始倒计时
    startCountdown () {
      this.countdown-- // 倒计时开始
      COUNTDOWN = setInterval(() => {
        this.countdown--
        if (this.countdown === 0) { // 当倒计时到0时结束
          window.clearInterval(COUNTDOWN) // 清除定时器
          this.countdown = 60 // 将倒计时恢复60s默认状态
        }
      }, 1000)
    },
    // handler
    handleValidate () {
      if (!this.$utils.checkEmptyRules(this.userInfo, this.validationCompanyRules) && this.$utils.phone(this.userInfo.mobile)) {
        let params = {
          phone: this.userInfo.mobile,
          code: this.userInfo.code,
          bizType: 'reg_mobile'
        }
        user.checkCode(params).then((res) => {
          this.checkToken = res.data.checkToken
          this.$message.success('验证成功')
          this.isCompleteVerification = true
          this.getMarket()// 获取市场
        })
      }
    },
    handleResetPassword () {
      // 验证各个必填项是否已填写规范
      if (!this.$utils.checkEmptyRules(this.userInfo, this.pswCompanyRules) && this.$utils.password(this.userInfo.password) && this.$utils.confirmPassword(this.userInfo.password, this.userInfo.confirmPassword)) {
        let params = {
          marketId: this.userInfo.marketId,
          phone: this.userInfo.mobile,
          newloginPwd: this.userInfo.password,
          checkToken: this.checkToken
        }
        user.resetPsw(params).then(() => {
          this.$message.success('密码修改成功！')
          setTimeout(() => { // 成功后跳转登录页，给个2s缓冲时间
            this.$router.replace({ path: '/login' })
          }, 2000)
        }).catch((err) => {
          // 验证不通过，跳转回验证页面
          this.$message.error(err)
          this.userInfo.code = ''
          this.isCompleteVerification = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .forget-password-title {
    font-size: 16px;
    margin: 20px 0;
  }
  .password_type{
    width: 20px;
    margin-top: 10px;
    margin-right: 4px;
  }
}
</style>
